import * as config from "../constants/config";
import * as componentTypes from "../constants/componentTypes";
import * as permissions from "../constants/permissions";
import * as rcc from "../constants/rcc";
import * as settings from "../constants/settings";
import * as resolutions from "../constants/resolutions";
import * as resources from "../constants/resources";
import * as settingsActions from "../actions/settingsActions";
import * as itemTypes from "../constants/itemTypes";
import * as modules from "../constants/modules";
import * as priceTypes from "../constants/priceTypes";
import * as styles from "../constants/styles";

export const getObjectByName = (list, name) => {
    let item;
    for (item of list) {
        if (item.name === name) {
            return item;
        }
    }

    return null;
};

export const getObjectByDisplayName = (list, name) => {
    let item;
    for (item of list) {
        if (item.displayName === name) {
            return item;
        }
    }

    return null;
};

export const getObjectByCode = (list, code) => {
    let item;
    for (item of list) {
        if (item.code === code) {
            return item;
        }
    }

    return null;
};

export const getObjectByKey = (list, key) => {
    let item;
    for (item of list) {
        if (item.key === key) {
            return item;
        }
    }

    return null;
};

export const getObjectById = (list, id) => {
    let item;
    for (item of list) {
        if (item.id === id) {
            return item;
        }
    }

    return null;
};

export const getObjectByIndex = (list, index, value) => {
    let item;
    for (item of list) {
        if (item[index] === value) {
            return item;
        }
    }

    return null;
};

export const getTreeObjectById = (tree, id) => {
    let item, node;
    for (node of tree) {
        for (item of node.items) {
            if (item && item.id === id) {
                return item;
            }
        }

        if (node.nodes.length > 0) {
            let result = getTreeObjectById(node.nodes, id);

            if (result !== null) {
                return result;
            }
        }
    }

    return null;
};

export const getTreeObjectByName = (tree, name) => {
    let item, node;
    for (node of tree) {
        for (item of node.items) {
            if (item && item.displayName === name) {
                return item;
            }
        }

        if (node.nodes.length > 0) {
            let result = getTreeObjectByName(node.nodes, name);

            if (result !== null) {
                return result;
            }
        }
    }

    return null;
};

export const getSimpleTreeObjectById = (tree, id) => {
    let node;
    for (node of tree) {
        if (node.item && node.item.id === id) {
            return node.item;
        }

        if (node.nodes.length > 0) {
            let result = getSimpleTreeObjectById(node.nodes, id);

            if (result !== null) {
                return result;
            }
        }
    }

    return null;
};

export const getNextListItemIndex = (list, activeIndex) => {
    if (!list.length) {
        return null;
    }

    if (activeIndex === null) {
        return 0;
    }

    if (activeIndex === list.length - 1 || activeIndex === list.length - 2) {
        return list.length - 1;
    }

    return activeIndex + 1;
};

export const getNextEnabledListChannelId = (list, activeId) => {
    if (!list.length) {
        return null;
    }

    if (activeId === null) {
        activeId = 1;
    }

    let id, item;
    for (id = activeId + 1; id <= list.length; id++) {
        item = getObjectById(list, id);
        if (item && item.enabled) {
            return id;
        }
    }

    return null;
};

export const getPreviousListItemIndex = (list, activeIndex) => {
    if (!list.length) {
        return null;
    }

    if (activeIndex === null || activeIndex === 0) {
        return 0;
    }

    return activeIndex - 1;
};

export const getPreviousEnabledListChannelId = (list, activeId) => {
    if (!list.length) {
        return null;
    }

    if (activeId === null) {
        activeId = list.length;
    }

    let id;
    for (id = activeId - 1; id > 0; id--) {
        let item = getObjectById(list, id);
        if (item && item.enabled) {
            return id;
        }
    }

    return null;
};

export const getPriceObjectByType = (list, type) => {
    if (!list || list.length === 0) {
        return null;
    }

    for (let item of list) {
        if (item.priceType === type) {
            return item;
        }
    }

    return null;
};

export const containsSettingsMenuItem = (settingsMenu, activeSubmenuItem) => {
    let submenuResult;

    let item;
    for (item of settingsMenu.items) {
        if (item.name === activeSubmenuItem) {
            return true;
        }

        if (item.items && item.items.length > 0) {
            submenuResult = containsSettingsMenuItem(item, activeSubmenuItem);

            if (submenuResult) {
                return true;
            }
        }
    }

    return false;
};

export const getActiveSettingsMenuContent = (settingsSubmenu, activeSubmenuItem) => {
    if (settingsSubmenu === null || activeSubmenuItem === null) {
        return null;
    }

    let submenuResult;

    let submenuItem;
    for (submenuItem of settingsSubmenu.items) {
        if (submenuItem.name === activeSubmenuItem) {
            let result = [];

            let contentItem;
            for (contentItem of submenuItem.items) {
                if (
                    contentItem.type === componentTypes.SETTINGS_SUBMENU ||
                    contentItem.type === componentTypes.SETTINGS_OPTION
                ) {
                    result.push(contentItem);
                }
            }

            return result;
        }

        if (submenuItem.items && submenuItem.items.length > 0) {
            submenuResult = getActiveSettingsMenuContent(submenuItem, activeSubmenuItem);

            if (submenuResult !== null) {
                return submenuResult;
            }
        }
    }

    return null;
};

export const getSettingsMenuPrivileges = (settingsMenu) => {
    if (settingsMenu === null) {
        return {};
    }

    let visibleItems = {};

    let submenuItem, visibleSubItems, some, item;
    for (submenuItem of settingsMenu.items) {
        if (
            submenuItem.type === componentTypes.SETTINGS_MAIN_MENU ||
            submenuItem.type === componentTypes.SETTINGS_LEFT_MENU ||
            submenuItem.type === componentTypes.SETTINGS_SUBMENU
        ) {
            if (submenuItem.visible) {
                if (submenuItem.items && submenuItem.items.length > 0) {
                    some = submenuItem.items.some(
                        (option) => option.type === componentTypes.SETTINGS_OPTION && option.editable
                    );

                    visibleSubItems = getSettingsMenuPrivileges(submenuItem);

                    for (item in visibleSubItems) {
                        visibleItems[item] = visibleSubItems[item];

                        if (visibleSubItems[item] === permissions.AVAILABLE) {
                            some = true;
                        }
                    }

                    visibleItems[submenuItem.name] = some ? permissions.AVAILABLE : permissions.NOT_AVAILABLE;
                } else {
                    visibleItems[submenuItem.name] = permissions.NOT_AVAILABLE;
                }
            } else {
                visibleItems[submenuItem.name] = permissions.HIDDEN;
            }
        }
    }

    return visibleItems;
};

export const getSettingsMenuShortCuts = (settingsMenu, inputWords) => {
    let item;
    let itemTree = [];

    for (item of settingsMenu.items) {
        if (item.type === componentTypes.SETTINGS_OPTION) {
            if (item.keyWords.some((keyWord) => inputWords.some((input) => keyWord.includes(input)))) {
                itemTree.push(item);
            }
        }

        if (item.items !== undefined && item.items.length > 0) {
            let subItem = getSettingsMenuShortCuts(item, inputWords);

            if (subItem.length > 0) {
                itemTree.push(...subItem);
            }
        }
    }

    return itemTree;
};

export const getSettingsMenuItemByName = (settingsMenu, name) => {
    let item;

    for (item of settingsMenu.items) {
        if (item.name === name) {
            return item;
        }

        if (item.items !== undefined && item.items.length > 0) {
            let subItem = getSettingsMenuItemByName(item, name);
            if (subItem) {
                return subItem;
            }
        }
    }

    return null;
};

export const getMenuItemPath = (settingsMenu, name) => {
    let item;

    for (item of settingsMenu.items) {
        if (item.name === name) {
            return [item];
        }

        if (item.items !== undefined && item.items.length > 0) {
            let subItems = getMenuItemPath(item, name);

            if (subItems !== null) {
                subItems.push(item);
                return subItems;
            }
        }
    }

    return null;
};

export const getUrlByIpAndPort = (ip, port) => {
    return config.WEBSOCKET_PROTOCOL + ip + ":" + port;
};

export const isFormulaTab = (type) => {
    return (
        type === componentTypes.INITIAL_TAB ||
        type === componentTypes.COLOR_TAB ||
        type === componentTypes.MAIN_TAB ||
        type === componentTypes.COLOR_SEARCH_TAB
    );
};

export const hasFormulaStore = (type) => {
    return (
        type === componentTypes.MAIN_TAB ||
        type === componentTypes.INITIAL_TAB ||
        type === componentTypes.COLOR_TAB ||
        type === componentTypes.FAVORITES_TAB ||
        type === componentTypes.CUSTOM_TAB ||
        type === componentTypes.MATCHING_TAB ||
        type === componentTypes.COLOR_SEARCH_TAB
    );
};

export const isFormulaTabById = (id, tabList) => {
    for (let tab of tabList) {
        if (tab.id === id) {
            return isFormulaTab(tab.type);
        }
    }

    return false;
};

export const getNumberOfFormulaTabs = (tabList) => {
    let count = 0;

    let tab;
    for (tab of tabList) {
        if (isFormulaTab(tab.type)) {
            count++;
        }
    }

    return count;
};

export const getLastFormulaTab = (tabList) => {
    let lastTab = null;

    let tab;
    for (tab of tabList) {
        if (tab.type === componentTypes.INITIAL_TAB || tab.type === componentTypes.MAIN_TAB) {
            lastTab = tab;
        }
    }

    if (lastTab !== null) {
        return lastTab;
    }

    for (tab of tabList) {
        if (tab.type === componentTypes.COLOR_TAB) {
            lastTab = tab;
        }
    }

    return lastTab;
};

const getCanisterByColorant = (colorant, canisterList) => {
    for (let canister of canisterList) {
        if (canister.colorant !== null && canister.colorant.name === colorant.name) {
            return canister;
        }
    }

    return null;
};

export const getCanisterByColorantPackage = (colorantName, canisterList) => {
    for (let canister of canisterList) {
        if (canister.colorant !== null && canister.colorant.name === colorantName) {
            return canister;
        }
    }

    return null;
};

export const getFormulaUfiCodes = (colorantList, canisterList, ufiCodeLogic) => {
    let result = {};

    if (
        ufiCodeLogic === settings.UFI_CODE_LOGIC_HIGHEST_CONCENTRATION_CANISTER ||
        ufiCodeLogic === settings.UFI_CODE_LOGIC_LAST_REFILL_CANISTER
    ) {
        let canister;
        for (let colorant of colorantList) {
            canister = getCanisterByColorant(colorant, canisterList);
            result[colorant.name] = canister === null ? null : canister.ufi;
        }

        return result;
    }

    for (let colorant of colorantList) {
        result[colorant.name] = colorant.ufi;
    }

    return result;
};

export const getFormulaColorantBatchNumbers = (colorantList, canisterList) => {
    let result = {};

    let canister;
    for (let colorant of colorantList) {
        canister = getCanisterByColorant(colorant, canisterList);
        result[colorant.name] = canister === null ? null : canister.batch;
    }

    return result;
};

export const getFormulaCanisterBatchNumbers = (colorantList, canisterList, allBatchNumbersList) => {
    let result = {};

    let canister;
    let canisterId;
    let colorant;
    for (colorant of colorantList) {
        canister = getCanisterByColorant(colorant, canisterList);
        if (canister) {
            result[colorant.id] = [];

            for (canisterId of Object.keys(allBatchNumbersList)) {
                if (canisterId == canister.id) {
                    allBatchNumbersList[canisterId].map((x) => {
                        result[colorant.id].push(x.batchNumber);
                    });
                }
            }
        }
    }

    return result;
};

const getValidBarcodeRefillValue = (machineConfigurationList) => {
    if (machineConfigurationList[rcc.CONFIG_BARCODE_REFILL]) {
        return settings.RCC_ENABLED;
    }

    if (machineConfigurationList[rcc.CONFIG_BARCODE_REFILL_COLORANT_CHECK]) {
        return settings.RCC_COLORANT_PACKAGE;
    }

    return settings.RCC_DISABLED;
};

const getValidManualColorantAdditionValue = (machineConfigurationList) => {
    if (machineConfigurationList[rcc.CONFIG_MANUAL_COLORANT_ADDITION] === rcc.RCC_MACHINE_SETTING_ENABLE) {
        return settings.RCC_ENABLED;
    }

    if (machineConfigurationList[rcc.CONFIG_MANUAL_COLORANT_ADDITION] === rcc.RCC_MACHINE_SETTING_ASK) {
        return settings.RCC_ASK;
    }

    return settings.RCC_DISABLED;
};

const getValidSplitFormulaValue = (machineConfigurationList) => {
    if (machineConfigurationList[rcc.CONFIG_SPLIT_FORMULA] === rcc.RCC_MACHINE_SETTING_ENABLE) {
        return settings.RCC_ENABLED;
    }

    if (machineConfigurationList[rcc.CONFIG_SPLIT_FORMULA] === rcc.RCC_MACHINE_SETTING_ASK) {
        return settings.RCC_ASK;
    }

    return settings.RCC_DISABLED;
};

export const synchronizeMachineConfiguration = (
    machineConfigurationList,
    ufiCodeLogic,
    ufiCodeBaseValidation,
    barcodeRefill,
    baseCanBarcodeValidation,
    checkCanBeforeDispense,
    checkOverfill,
    colorantBatchNumberLogic,
    dispenseInvalidColorants,
    manualColorantAddition,
    minimalDispenseAmount,
    placeCanSensor,
    placeCanSensorDelay,
    removeCanSensor,
    removeCanSensorDelay,
    skipPlaceCanDialog,
    skipRemoveCanDialog,
    splitFormula,
    tmcEnabled,
    unit,
    validateColorantsDuringInit
) => {
    if (machineConfigurationList === null) {
        return null;
    }

    let configuration = null;

    if (machineConfigurationList[rcc.CONFIG_READ_BASE_UFI_CODE] !== undefined) {
        if (
            machineConfigurationList[rcc.CONFIG_READ_BASE_UFI_CODE] !==
            (ufiCodeLogic !== settings.UFI_CODE_LOGIC_DISABLED &&
                ufiCodeBaseValidation !== settings.UFI_CODE_BASE_VALIDATION_DISABLED)
        ) {
            if (configuration === null) {
                configuration = {};
            }

            configuration[rcc.CONFIG_READ_BASE_UFI_CODE] = !machineConfigurationList[rcc.CONFIG_READ_BASE_UFI_CODE];
        }
    }

    if (
        machineConfigurationList[rcc.CONFIG_UFI_USE_LAST_REFILL] !== undefined &&
        (ufiCodeLogic === settings.UFI_CODE_LOGIC_HIGHEST_CONCENTRATION_CANISTER ||
            ufiCodeLogic === settings.UFI_CODE_LOGIC_LAST_REFILL_CANISTER)
    ) {
        if (
            machineConfigurationList[rcc.CONFIG_UFI_USE_LAST_REFILL] !==
            (ufiCodeLogic === settings.UFI_CODE_LOGIC_LAST_REFILL_CANISTER)
        ) {
            if (configuration === null) {
                configuration = {};
            }

            configuration[rcc.CONFIG_UFI_USE_LAST_REFILL] = !machineConfigurationList[rcc.CONFIG_UFI_USE_LAST_REFILL];
        }
    }

    if (
        machineConfigurationList[rcc.CONFIG_BATCH_USE_LAST_REFILL] !== undefined &&
        (colorantBatchNumberLogic === settings.COLORANT_BATCH_NUMBER_LOGIC_LAST_REFILL_CANISTER ||
            colorantBatchNumberLogic === settings.COLORANT_BATCH_NUMBER_LOGIC_HIGHEST_CONCENTRATION_CANISTER)
    ) {
        if (
            machineConfigurationList[rcc.CONFIG_BATCH_USE_LAST_REFILL] !==
            (colorantBatchNumberLogic === settings.COLORANT_BATCH_NUMBER_LOGIC_LAST_REFILL_CANISTER)
        ) {
            if (configuration === null) {
                configuration = {};
            }

            configuration[rcc.CONFIG_BATCH_USE_LAST_REFILL] =
                !machineConfigurationList[rcc.CONFIG_BATCH_USE_LAST_REFILL];
        }
    }

    if (getValidBarcodeRefillValue(machineConfigurationList) !== barcodeRefill) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_BARCODE_REFILL] = barcodeRefill === settings.RCC_ENABLED;
        configuration[rcc.CONFIG_BARCODE_REFILL_COLORANT_CHECK] = barcodeRefill === settings.RCC_COLORANT_PACKAGE;
    }

    if (machineConfigurationList[rcc.CONFIG_BASE_CAN_BARCODE_VALIDATION] !== baseCanBarcodeValidation) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_BASE_CAN_BARCODE_VALIDATION] = baseCanBarcodeValidation;
    }

    if (machineConfigurationList[rcc.CONFIG_CHECK_CAN_BEFORE_DISPENSE] !== checkCanBeforeDispense) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_CHECK_CAN_BEFORE_DISPENSE] = checkCanBeforeDispense;
    }

    if (machineConfigurationList[rcc.CONFIG_CHECK_OVERFILL] !== checkOverfill) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_CHECK_OVERFILL] = checkOverfill;
    }

    if (machineConfigurationList[rcc.CONFIG_DISPENSE_INVALID_COLORANTS] !== dispenseInvalidColorants) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_DISPENSE_INVALID_COLORANTS] = dispenseInvalidColorants;
    }

    if (getValidManualColorantAdditionValue(machineConfigurationList) !== manualColorantAddition) {
        if (configuration === null) {
            configuration = {};
        }

        if (manualColorantAddition === settings.RCC_ENABLED) {
            configuration[rcc.CONFIG_MANUAL_COLORANT_ADDITION] = rcc.RCC_MACHINE_SETTING_ENABLE;
        } else if (manualColorantAddition === settings.RCC_ASK) {
            configuration[rcc.CONFIG_MANUAL_COLORANT_ADDITION] = rcc.RCC_MACHINE_SETTING_ASK;
        } else {
            configuration[rcc.CONFIG_MANUAL_COLORANT_ADDITION] = rcc.RCC_MACHINE_SETTING_DISABLE;
        }
    }

    if (machineConfigurationList[rcc.CONFIG_MINIMAL_DISPENSE_AMOUNT] !== minimalDispenseAmount) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_MINIMAL_DISPENSE_AMOUNT] = minimalDispenseAmount;
    }

    if (machineConfigurationList[rcc.CONFIG_PLACE_CAN_SENZOR] !== placeCanSensor) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_PLACE_CAN_SENZOR] = placeCanSensor;
    }

    if (machineConfigurationList[rcc.CONFIG_PLACE_CAN_SENZOR_DELAY] !== placeCanSensorDelay) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_PLACE_CAN_SENZOR_DELAY] = placeCanSensorDelay;
    }

    if (machineConfigurationList[rcc.CONFIG_REMOVE_CAN_SENZOR] !== removeCanSensor) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_REMOVE_CAN_SENZOR] = removeCanSensor;
    }

    if (machineConfigurationList[rcc.CONFIG_REMOVE_CAN_SENZOR_DELAY] !== removeCanSensorDelay) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_REMOVE_CAN_SENZOR_DELAY] = removeCanSensorDelay;
    }

    if (machineConfigurationList[rcc.CONFIG_SKIP_PLACE_CAN_DIALOG] !== skipPlaceCanDialog) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_SKIP_PLACE_CAN_DIALOG] = removeCanSensorDelay;
    }

    if (machineConfigurationList[rcc.CONFIG_SKIP_REMOVE_CAN_DIALOG] !== skipRemoveCanDialog) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_SKIP_REMOVE_CAN_DIALOG] = skipRemoveCanDialog;
    }

    if (getValidSplitFormulaValue(machineConfigurationList) !== splitFormula) {
        if (configuration === null) {
            configuration = {};
        }

        if (splitFormula === settings.RCC_ENABLED) {
            configuration[rcc.CONFIG_SPLIT_FORMULA] = rcc.RCC_MACHINE_SETTING_ENABLE;
        } else if (splitFormula === settings.RCC_ASK) {
            configuration[rcc.CONFIG_SPLIT_FORMULA] = rcc.RCC_MACHINE_SETTING_ASK;
        } else {
            configuration[rcc.CONFIG_SPLIT_FORMULA] = rcc.RCC_MACHINE_SETTING_DISABLE;
        }
    }

    if (machineConfigurationList[rcc.CONFIG_TMC_ENABLED] !== tmcEnabled) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_TMC_ENABLED] = tmcEnabled;
    }

    if (machineConfigurationList[rcc.CONFIG_UNIT] !== unit) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_UNIT] = unit;
    }

    if (machineConfigurationList[rcc.CONFIG_VALIDATE_COLORANTS_DURING_INIT] !== validateColorantsDuringInit) {
        if (configuration === null) {
            configuration = {};
        }

        configuration[rcc.CONFIG_VALIDATE_COLORANTS_DURING_INIT] = validateColorantsDuringInit;
    }

    return configuration;
};

export const synchronizeMachineConfigurationToServer = (
    configuration,
    barcodeRefill,
    baseCanBarcodeValidation,
    checkCanBeforeDispense,
    checkOverfill,
    dispenseInvalidColorants,
    manualColorantAddition,
    minimalDispenseAmount,
    placeCanSensor,
    placeCanSensorDelay,
    removeCanSensor,
    removeCanSensorDelay,
    skipPlaceCanDialog,
    skipRemoveCanDialog,
    splitFormula,
    tmcEnabled,
    unit,
    validateColorantsDuringInit
) => {
    if (configuration === null) {
        return null;
    }

    if (getValidBarcodeRefillValue(configuration) !== barcodeRefill) {
        if (configuration[rcc.CONFIG_BARCODE_REFILL]) {
            return settingsActions.setRccBarcodeRefill(settings.RCC_ENABLED);
        } else if (configuration[rcc.CONFIG_BARCODE_REFILL_COLORANT_CHECK]) {
            return settingsActions.setRccBarcodeRefill(settings.RCC_COLORANT_PACKAGE);
        } else {
            return settingsActions.setRccBarcodeRefill(settings.RCC_DISABLED);
        }
    }

    if (configuration[rcc.CONFIG_BASE_CAN_BARCODE_VALIDATION] !== baseCanBarcodeValidation) {
        return settingsActions.setRccBaseCanBarcodeValidation(configuration[rcc.CONFIG_BASE_CAN_BARCODE_VALIDATION]);
    }

    if (configuration[rcc.CONFIG_CHECK_CAN_BEFORE_DISPENSE] !== checkCanBeforeDispense) {
        return settingsActions.setRccCheckCanBeforeDispense(configuration[rcc.CONFIG_CHECK_CAN_BEFORE_DISPENSE]);
    }

    if (configuration[rcc.CONFIG_CHECK_OVERFILL] !== checkOverfill) {
        return settingsActions.setRccCheckOverfill(configuration[rcc.CONFIG_CHECK_OVERFILL]);
    }

    if (configuration[rcc.CONFIG_DISPENSE_INVALID_COLORANTS] !== dispenseInvalidColorants) {
        return settingsActions.setRccDispenseInvalidColorants(configuration[rcc.CONFIG_DISPENSE_INVALID_COLORANTS]);
    }

    if (getValidManualColorantAdditionValue(configuration) !== manualColorantAddition) {
        if (configuration[rcc.CONFIG_MANUAL_COLORANT_ADDITION] === rcc.RCC_MACHINE_SETTING_ENABLE) {
            return settingsActions.setRccManualColorantAddition(settings.RCC_ENABLED);
        } else if (configuration[rcc.CONFIG_MANUAL_COLORANT_ADDITION] === rcc.RCC_MACHINE_SETTING_ASK) {
            return settingsActions.setRccManualColorantAddition(settings.RCC_ASK);
        } else {
            return settingsActions.setRccManualColorantAddition(settings.RCC_DISABLED);
        }
    }

    if (configuration[rcc.CONFIG_MINIMAL_DISPENSE_AMOUNT] !== minimalDispenseAmount) {
        return settingsActions.setRccMinimalDispenseAmount(configuration[rcc.CONFIG_MINIMAL_DISPENSE_AMOUNT]);
    }

    if (configuration[rcc.CONFIG_PLACE_CAN_SENZOR] !== placeCanSensor) {
        return settingsActions.setRccPlaceCanSensor(configuration[rcc.CONFIG_PLACE_CAN_SENZOR]);
    }

    if (configuration[rcc.CONFIG_PLACE_CAN_SENZOR_DELAY] !== placeCanSensorDelay) {
        return settingsActions.setRccPlaceCanSensorDelay(configuration[rcc.CONFIG_PLACE_CAN_SENZOR_DELAY]);
    }

    if (configuration[rcc.CONFIG_REMOVE_CAN_SENZOR] !== removeCanSensor) {
        return settingsActions.setRccRemoveCanSensor(configuration[rcc.CONFIG_REMOVE_CAN_SENZOR]);
    }

    if (configuration[rcc.CONFIG_REMOVE_CAN_SENZOR_DELAY] !== removeCanSensorDelay) {
        return settingsActions.setRccRemoveCanSensorDelay(configuration[rcc.CONFIG_REMOVE_CAN_SENZOR_DELAY]);
    }

    if (configuration[rcc.CONFIG_SKIP_PLACE_CAN_DIALOG] !== skipPlaceCanDialog) {
        return settingsActions.setRccSkipPlaceCanDialog(configuration[rcc.CONFIG_SKIP_PLACE_CAN_DIALOG]);
    }

    if (configuration[rcc.CONFIG_SKIP_REMOVE_CAN_DIALOG] !== skipRemoveCanDialog) {
        return settingsActions.setRccSkipRemoveCanDialog(configuration[rcc.CONFIG_SKIP_REMOVE_CAN_DIALOG]);
    }

    if (getValidSplitFormulaValue(configuration) !== splitFormula) {
        if (configuration[rcc.CONFIG_SPLIT_FORMULA] === rcc.RCC_MACHINE_SETTING_ENABLE) {
            return settingsActions.setRccSplitFormula(settings.RCC_ENABLED);
        } else if (configuration[rcc.CONFIG_SPLIT_FORMULA] === rcc.RCC_MACHINE_SETTING_ASK) {
            return settingsActions.setRccSplitFormula(settings.RCC_ASK);
        } else {
            return settingsActions.setRccSplitFormula(settings.RCC_DISABLED);
        }
    }

    if (configuration[rcc.CONFIG_TMC_ENABLED] !== tmcEnabled) {
        return settingsActions.setRccTmcEnabled(configuration[rcc.CONFIG_TMC_ENABLED]);
    }

    if (configuration[rcc.CONFIG_UNIT] !== unit) {
        return settingsActions.setRccUnit(configuration[rcc.CONFIG_UNIT]);
    }

    if (configuration[rcc.CONFIG_VALIDATE_COLORANTS_DURING_INIT] !== validateColorantsDuringInit) {
        return settingsActions.setRccValidateColorantsDuringInit(
            configuration[rcc.CONFIG_VALIDATE_COLORANTS_DURING_INIT]
        );
    }

    return null;
};

export const synchronizeHelperConfiguration = (
    helperConfiguration,
    autoCheck,
    autoCheckInterval,
    autoDownload,
    autoForceInstall,
    autoInstall,
    autoInstallDelay,
    autoInstallNewDbs,
    autoNightCheck,
    autoRebootDelay
) => {
    if (helperConfiguration === null) {
        return null;
    }

    let configuration = null;

    if (helperConfiguration.autoCheck !== autoCheck) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.check = autoCheck;
    }

    if (helperConfiguration.autoInterval !== autoCheckInterval) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.interval = autoCheckInterval;
    }

    if (helperConfiguration.autoDownload !== autoDownload) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.download = autoDownload;
    }

    if (helperConfiguration.autoForceInstall !== autoForceInstall) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.force_install = autoForceInstall;
    }

    if (helperConfiguration.autoInstall !== autoInstall) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.install = autoInstall;
    }

    if (helperConfiguration.autoInstallDelay !== autoInstallDelay) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.install_delay = autoInstallDelay;
    }

    if (helperConfiguration.autoInstallNewDatabases !== autoInstallNewDbs) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.install_new_dbs = autoInstallNewDbs;
    }

    if (helperConfiguration.autoNightCheck !== autoNightCheck) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.night_check = autoNightCheck;
    }

    if (helperConfiguration.autoRebootDelay !== autoRebootDelay) {
        if (configuration === null) {
            configuration = {};
        }

        configuration.reboot_delay = autoRebootDelay;
    }

    return configuration;
};

export const synchronizeHelperConfigurationToServer = (
    configuration,
    autoCheck,
    autoCheckInterval,
    autoDownload,
    autoForceInstall,
    autoInstall,
    autoInstallDelay,
    autoInstallNewDbs,
    autoNightCheck,
    autoRebootDelay
) => {
    if (configuration === null) {
        return [];
    }

    let actions = [];

    if (configuration.Auto.check !== autoCheck) {
        actions.push(settingsActions.setHelperAutoCheck(configuration.Auto.check));
    }

    if (configuration.Auto.interval !== autoCheckInterval) {
        actions.push(settingsActions.setHelperAutoCheckInterval(configuration.Auto.interval));
    }

    if (configuration.Auto.download !== autoDownload) {
        actions.push(settingsActions.setHelperAutoDownload(configuration.Auto.download));
    }

    if (configuration.Auto.install !== autoInstall) {
        actions.push(settingsActions.setHelperAutoInstall(configuration.Auto.install));
    }

    if (configuration.Auto.force_install !== autoForceInstall) {
        actions.push(settingsActions.setHelperAutoForceInstall(configuration.Auto.force_install));
    }

    if (configuration.Auto.install_delay !== autoInstallDelay) {
        actions.push(settingsActions.setHelperAutoInstallDelay(configuration.Auto.install_delay));
    }

    if (configuration.Auto.install_new_dbs !== autoInstallNewDbs) {
        actions.push(settingsActions.setHelperAutoInstallNewDbs(configuration.Auto.install_new_dbs));
    }

    if (configuration.Auto.night_check !== autoNightCheck) {
        actions.push(settingsActions.setHelperAutoInstallNightCheck(configuration.Auto.night_check));
    }

    if (configuration.Auto.reboot_delay !== autoRebootDelay) {
        actions.push(settingsActions.setHelperAutoRebootDelay(configuration.Auto.reboot_delay));
    }

    return actions;
};

export const getRecommendedZoomByResolution = (resolution) => {
    if (!Array.isArray(resolution)) {
        return resolutions.RESOLUTION_ZOOM_DEFAULT;
    }

    const width = resolution[0];
    const height = resolution[1];

    if (width < 1152) {
        return resolutions.RESOLUTION_ZOOM_1024_768;
    }

    if (width < 1280) {
        return resolutions.RESOLUTION_ZOOM_1152_864;
    }

    if (width < 1360) {
        if (height < 720) {
            return resolutions.RESOLUTION_ZOOM_1280_600;
        }

        if (height < 768) {
            return resolutions.RESOLUTION_ZOOM_1280_720;
        }

        if (height < 800) {
            return resolutions.RESOLUTION_ZOOM_1280_768;
        }

        if (height < 966) {
            return resolutions.RESOLUTION_ZOOM_1280_800;
        }

        if (height < 1024) {
            return resolutions.RESOLUTION_ZOOM_1280_966;
        }

        return resolutions.RESOLUTION_ZOOM_1280_1024;
    }

    if (width < 1366) {
        return resolutions.RESOLUTION_ZOOM_1360_768;
    }

    if (width < 1400) {
        return resolutions.RESOLUTION_ZOOM_1366_768;
    }

    if (width < 1440) {
        return resolutions.RESOLUTION_ZOOM_1400_1050;
    }

    if (width < 1536) {
        return resolutions.RESOLUTION_ZOOM_1440_900;
    }

    if (width < 1600) {
        return resolutions.RESOLUTION_ZOOM_1536_864;
    }

    if (width < 1680) {
        if (height < 1200) {
            return resolutions.RESOLUTION_ZOOM_1600_900;
        }

        return resolutions.RESOLUTION_ZOOM_1600_1200;
    }

    if (width < 1920) {
        return resolutions.RESOLUTION_ZOOM_1680_1050;
    }

    return resolutions.RESOLUTION_ZOOM_1920_1080;
};

export const getFlashMessagesStatus = (flashMessages) => {
    let status = null;
    let statusPriority = -1;

    for (let flasMessage of flashMessages) {
        switch (flasMessage.type) {
            case componentTypes.FLASH_MESSAGE_ERROR:
                if (statusPriority < 3) {
                    status = componentTypes.FLASH_MESSAGE_ERROR;
                    statusPriority = 3;
                }
                break;
            case componentTypes.FLASH_MESSAGE_WARNING:
                if (statusPriority < 2) {
                    status = componentTypes.FLASH_MESSAGE_WARNING;
                    statusPriority = 2;
                }
                break;
            case componentTypes.FLASH_MESSAGE_SUCCESS:
                if (statusPriority < 1) {
                    status = componentTypes.FLASH_MESSAGE_SUCCESS;
                    statusPriority = 1;
                }
                break;
            case componentTypes.FLASH_MESSAGE_INFO:
                if (statusPriority < 0) {
                    status = componentTypes.FLASH_MESSAGE_INFO;
                    statusPriority = 0;
                }
                break;
            default:
                break;
        }
    }

    return status;
};

export const getNextRequest = (list, id) => {
    let item = getObjectById(list, id);

    if (item === null) {
        return null;
    }

    return item.next;
};

export const getStockItemKey = (itemTypeId, item) => {
    if (item === null) {
        return null;
    }

    switch (itemTypeId) {
        case itemTypes.COLORANT_PACKAGE:
            return itemTypeId + "-" + item.colorant.name + "-" + item.package.name;
        default:
            return null;
    }
};

export const getStyleBySoftware = (softwareType) => {
    switch (softwareType) {
        case modules.SOFTWARE_LIGHT:
        case modules.SOFTWARE_WEBER:
            return styles.REDLIKE_LIGHT_STYLE;
        case modules.SOFTWARE_GAMMA:
            return styles.GAMMA_STYLE;
        default:
            return styles.REDLIKE_STYLE;
    }
};

export const getValidActiveUnit = (lastUsedUnit, visibleUnits, tabType, machineTypeName) => {
    switch (lastUsedUnit) {
        case settings.UNIT_ML:
            if (visibleUnits.ml) {
                return settings.UNIT_ML;
            }

            if (visibleUnits.g) {
                return settings.UNIT_G;
            }

            if (visibleUnits.shots) {
                return settings.UNIT_SHOT;
            }

            return settings.UNIT_ML;
        case settings.UNIT_G:
            if (visibleUnits.g) {
                return settings.UNIT_G;
            }

            if (visibleUnits.ml) {
                return settings.UNIT_ML;
            }

            if (visibleUnits.shots) {
                return settings.UNIT_SHOT;
            }

            return settings.UNIT_ML;
        case settings.UNIT_SHOT:
            if (visibleUnits.shots) {
                return settings.UNIT_SHOT;
            }

            if (visibleUnits.ml) {
                return settings.UNIT_ML;
            }

            if (visibleUnits.g) {
                return settings.UNIT_G;
            }

            return settings.UNIT_ML;
        case settings.UNIT_MANUAL:
            if (
                tabType !== componentTypes.CUSTOM_TAB &&
                (machineTypeName === rcc.DRIVER_TYPE_MANUAL || machineTypeName === rcc.DRIVER_TYPE_MANUAL_SIMPLE)
            ) {
                return settings.UNIT_MANUAL;
            }

            if (visibleUnits.ml) {
                return settings.UNIT_ML;
            }

            if (visibleUnits.g) {
                return settings.UNIT_G;
            }

            if (visibleUnits.shots) {
                return settings.UNIT_SHOT;
            }

            return settings.UNIT_ML;
        default:
            return settings.UNIT_ML;
    }
};

export const getResourceByTabType = (tabType) => {
    switch (tabType) {
        case componentTypes.CANISTERS_TAB:
            return resources.COMPONENT_CANISTERS_TAB;
        case componentTypes.COLOR_SEARCH_TAB:
            return resources.COMPONENT_COLOR_SEARCH_TAB;
        case componentTypes.COLOR_TAB:
            return resources.COMPONENT_COLOR_TAB;
        case componentTypes.CUSTOM_TAB:
            return resources.COMPONENT_CUSTOM_FORMULA_TAB;
        case componentTypes.CUSTOMERS_TAB:
            return resources.COMPONENT_CUSTOMERS_TAB;
        case componentTypes.FAVORITES_TAB:
            return resources.COMPONENT_FAVORITES_TAB;
        case componentTypes.INITIAL_TAB:
        case componentTypes.MAIN_TAB:
            return resources.COMPONENT_FORMULA_TAB;
        case componentTypes.MATCHING_TAB:
            return resources.COMPONENT_MATCHING_TAB;
        case componentTypes.MY_ORDERS_TAB:
            return resources.COMPONENT_MY_ORDERS_TAB;
        case componentTypes.ORDERS_HISTORY_TAB:
            return resources.COMPONENT_HISTORY_OF_ORDERS_TAB;
        case componentTypes.SPECTRO_TAB:
            return resources.COMPONENT_SPECTRO_TAB;
        case componentTypes.STATISTICS_TAB:
            return resources.COMPONENT_STATISTICS_TAB;
        case componentTypes.TICKETING_TAB:
            return resources.COMPONENT_TICKETING_TAB;
        case componentTypes.TO_DISPENSE_TAB:
            return resources.COMPONENT_TO_DISPENSE_TAB;
        default:
            return null;
    }
};

export const getInvalidCalculatedFormulaColorants = (colorants, colorantList) => {
    let colorant = null;
    let invalidColorantList = [];
    for (let colorantName in colorants) {
        colorant = getObjectByName(colorantList, colorantName);

        if (colorant === null) {
            invalidColorantList.push(colorantName);
        }
    }

    return invalidColorantList;
};

export const getDefaultMargin = (marginList, showMargin, showMarkup, showDiscount) => {
    for (let margin of marginList) {
        if (margin.visible) {
            switch (margin.type) {
                case priceTypes.MARGIN_TYPE_MARGIN:
                    if (showMargin) {
                        return margin;
                    }
                    break;
                case priceTypes.MARGIN_TYPE_MARKUP:
                    if (showMarkup) {
                        return margin;
                    }
                    break;
                case priceTypes.MARGIN_TYPE_DISCOUNT:
                    if (showDiscount) {
                        return margin;
                    }
                    break;
                default:
                    break;
            }
        }
    }

    return null;
};
